import { inject, InjectionToken } from '@angular/core';
import { WINDOW } from './injectable-window';
import { DtrumApi, DynatraceApi } from '@dynatrace/dtrum-api-types/dtrum';

export const DT_RUM = new InjectionToken<DtrumApi | undefined>(
  'Dynatrace Real User Monitoring',
  {
    providedIn: 'root',
    factory: () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (inject(WINDOW) as any).dtrum as DtrumApi | undefined;
    },
  },
);

export const DYNATRACE = new InjectionToken<DynatraceApi | undefined>(
  'Dynatrace API',
  {
    providedIn: 'root',
    factory: () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (inject(WINDOW) as any).dynatrace as DynatraceApi | undefined;
    },
  },
);
